import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { getToken, getUser, type StoredUser } from "../../auth/auth";

interface SessionState {
  user: StoredUser | null;
  isAuthenticated: boolean;
}

const initialState: SessionState = {
  user: getUser(),
  isAuthenticated: Boolean(getToken()),
};

const sessionSlice = createSlice({
  name: "session",
  initialState,
  reducers: {
    setSession: (state, action: PayloadAction<{ user: StoredUser | null; isAuthenticated: boolean }>) => {
      state.user = action.payload.user;
      state.isAuthenticated = action.payload.isAuthenticated;
    },
    clearSession: (state) => {
      state.user = null;
      state.isAuthenticated = false;
    },
    setUserPartial: (state, action: PayloadAction<Partial<StoredUser>>) => {
      state.user = {
        ...(state.user || {}),
        ...action.payload,
      };
    },
  },
});

export const { setSession, clearSession, setUserPartial } = sessionSlice.actions;
export default sessionSlice.reducer;
